// MAIN ENTRY POINT FOR ENTIRE SITE

// add Feather Icons
// https://feathericons.com/
const feather = import(/* webpackChunkName: "feather-icons" */ 'feather-icons').then( (feather) => {
    feather.replace();
});

// if UTM tracking params are in the URL, append them to any <a> tag forwarding the user to
// another page
import {addUtmEventListener} from '@/js/global/helpers/url.js';
if (window.location.search.includes('utm_')) {
    addUtmEventListener();
}

window.onpageshow = (event) => {
    if (event.persisted) {
        window.location.reload();
    }
};